<div #wrapper class="wrapper" style="height: 100%;">
    <div class="modal-header-wrapper">
        <div class="text-wrapper" [class.font-weight-600]="true">{{ 'filtering' | localise }}</div>
        <div class="responsive-flex-wrapper shortcuts">
            <i class="ti-close" (click)="onFilter()"></i>
        </div>
    </div>

    <ng-container>
        <div class="modal-body">
            <div class="attributes">
                <div *ngFor="let attr of attributes" class="attribute">
                    <p class="attribute-title">
                        {{ attr.title }}
                    </p>

                    <ul>
                        <li *ngFor="let option of attr.options">
                            <div class="form-group">
                                <div class="form-check">
                                    <label class="form-check-label"><input
                                            class="form-check-input"
                                            name="attr_{{ attr.id }}" type="radio"
                                            (click)="markAttrOption(attr.id, option)" value="">
                                        {{ option.value }}
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="clear"></div>

            <div class="categories">
                <div class="attribute">
                    <p class="attribute-title">
                        {{ 'category' | localise }}
                    </p>

                    <ul>
                        <li *ngFor="let category of recipeCategories">
                            <div class="form-group">
                                <div class="form-check">
                                    <label class="form-check-label"><input
                                            class="form-check-input"
                                            name="category_{{ category.id }}" type="checkbox"
                                            (click)="markCategory(category, $event)" value="">
                                        {{ category.title }}
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="clear"></div>

            <div class="categories">
                <div class="attribute">
                    <p class="attribute-title">
                        {{ 'other' | localise }}
                    </p>

                    <ul>
                        <li>
                            <div class="form-group">
                                <div class="form-check">
                                    <label class="form-check-label"><input
                                            class="form-check-input"
                                            name="has_video" type="checkbox" (click)="changeHasVideo()"
                                            value="">
                                        {{ 'recipes_with_video' | localise }}
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="form-group">
                                <div class="form-check">
                                    <label class="form-check-label"><input
                                            class="form-check-input"
                                            name="has_video" type="checkbox" (click)="changeMealPrepFriendly()"
                                            value="">
                                        {{ 'recipes_meal_prep_friendly' | localise }}
                                        <i class="input-helper"></i>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="clear"></div>

            <button type="button" class="btn btn-success filter-btn"
                    (click)="onFilter()">{{ 'filter' | localise }}</button>
        </div>
    </ng-container>
</div>
